import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lp2-chat-bot-banner',
  templateUrl: './chat-bot-banner.component.html',
  styleUrls: ['./chat-bot-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'container',
  },
})
export class ChatBotBannerComponent {
  @Output()
  public openChatBotModal = new EventEmitter();

  public onOpenChatBotModal() {
    this.openChatBotModal.emit();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/chat-bot-banner/chat-bot-banner.component.ts